import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import { cn } from '@/utils/cn'
import { PepsaLogo } from '@/components/brand/PepsaLogo'

const publicLinks = [
  { label: 'Track delivery', href: '/track' },
  { label: 'Documentation', href: '/docs' },
  { label: 'Pricing', href: '/#pricing' },
  { label: 'Status', href: '/#status' },
] as const

export function AppLayout() {
  const location = useLocation()
  if (['/login', '/register', '/forgot-password', '/reset-password', '/invitation'].includes(location.pathname)) return <Outlet />
  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-40 border-b bg-white/95 backdrop-blur-xl">
        <div className="page-shell flex h-16 items-center justify-between gap-5">
          <Link to="/" className="flex items-center gap-2.5" aria-label="Pepsa home">
            <PepsaLogo />
          </Link>
          <nav aria-label="Primary navigation" className="hidden items-center gap-8 text-sm font-bold text-ink-700 md:flex">
            {publicLinks.map((item) => <NavLink key={item.label} to={item.href} className={({ isActive }) => cn('hover:text-ink-950', isActive && 'text-brand-600')}>{item.label}</NavLink>)}
          </nav>
          <div className="flex items-center gap-2">
            <NavLink to="/track" className="rounded-lg px-2 py-2 text-xs font-bold text-mint-600 md:hidden">Track</NavLink>
            <NavLink to="/login" className={({ isActive }) => cn('hidden rounded-lg px-4 py-2 text-sm font-bold sm:inline-flex', isActive && 'bg-sand-100')}>Log in</NavLink>
            <NavLink to="/register" className="button-primary min-h-9 px-4">Get API access</NavLink>
          </div>
        </div>
      </header>

      <Outlet />

      <footer className="border-t border-white/5 bg-[#111] text-white">
        <div className="page-shell grid gap-10 py-14 md:grid-cols-[1.2fr_2fr]">
          <div>
            <PepsaLogo inverse />
            <p className="mt-4 max-w-xs text-sm leading-6 text-white/50">Fast, reliable delivery infrastructure for businesses across Nigeria.</p>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {[
              ['Product', [['API documentation', '/docs'], ['Pricing', '/#pricing'], ['System status', '/#status']]],
              ['Company', [['About', '#'], ['Contact', '#'], ['Careers', '#']]],
              ['Legal', [['Privacy policy', '#'], ['Terms of service', '#'], ['Cookie policy', '#']]],
            ].map(([title, links]) => (
              <div key={title as string}>
                <p className="text-sm font-extrabold text-white/70">{title}</p>
                <div className="mt-4 grid gap-3 text-sm text-white/45">{(links as string[][]).map(([label, href]) => <a key={label} href={href} className="hover:text-white">{label}</a>)}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="page-shell flex flex-col gap-2 border-t border-white/10 py-5 text-xs text-white/30 sm:flex-row sm:justify-between"><p>© {new Date().getFullYear()} Pepsa Smart Delivery. All rights reserved.</p><p>api.pepsa.co v1</p></div>
      </footer>
    </div>
  )
}
